
         const script = document.createElement('script');
      script.type = 'module';
      script.src = `https://cdn.jsdelivr.net/npm/paymob-pixel@latest/main.js?v=${Math.random()}`;
      document.head.appendChild(script);
    